import { LICENSE_KEY } from '@global/constants/handsontable'
import { GridSettings } from 'handsontable/settings'

export const defaultOptions: GridSettings = {
  autoRowSize: false,
  autoWrapCol: false,
  autoWrapRow: false,
  colHeaders: true,
  columnHeaderHeight: 55,
  colWidths: 175,
  currentRowClassName: 'submisison-table-active-row',
  fillHandle: false,
  licenseKey: LICENSE_KEY,
  manualColumnResize: true,
  outsideClickDeselects: false,
  readOnly: false,
  rowHeaders: true,
  rowHeights: 35,
  startCols: 20,
  startRows: 50,
}
